export default "__VITE_ASSET__DqH7wV8l__"